<template>
  <v-app-bar
      :elevation="3"
      color="primary"
      class="sticky-header glass-effect"
      app
      fixed
  >
    <!-- Logo blanco alineado a la izquierda -->
    <v-app-bar-title class="logo-container">
      <img
          :src="require('@/assets/logo1.png')"
          alt="logo"
          class="logo"
      >
    </v-app-bar-title>

    <!-- Menú desktop -->
    <v-col class="d-flex justify-end">
      <div class="desktop-menu hidden-md-and-down">
        <template v-for="item in menuItems" :key="item.text">
          <v-btn
              size="x-large"
              class="menu-btn"
              variant="text"
              @click="scrollTo(item.section)"
          >
            <div class="btn-content">
              <v-icon size="28" class="menu-icon">{{ item.icon }}</v-icon>
              <span class="menu-text">{{ item.text }}</span>
            </div>
          </v-btn>
        </template>
      </div>
    </v-col>

    <!-- Menú móvil -->
    <template v-slot:append>
      <div class="mobile-menu">
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn icon v-bind="props">
              <v-icon size="28" class="mobile-menu-icon">mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
                v-for="item in menuItems"
                :key="item.text"
                @click="scrollTo(item.section)"
                class="mobile-menu-item"
            >
              <v-icon size="24" class="mr-2">{{ item.icon }}</v-icon>
              <v-list-item-title class="mobile-menu-text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  name: 'HeaderComp',
  data() {
    return {
      menuItems: [
        { text: "Inicio", icon: "mdi-home", section: "inicio" },
        { text: "Servicios", icon: "mdi-cog", section: "servicios" },
        { text: "Nuestros Proyectos", icon: "mdi-briefcase", section: "galeria" },
        { text: "Contacto", icon: "mdi-phone", section: "contacto" },
      ],
      isScrolled: false,
    };
  },
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
  }
};
</script>

<style scoped>
* {
  font-family: Arial, sans-serif;
}

.glass-effect {
  background: rgba(15, 96, 87, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.sticky-header {
  height: 80px;
  padding: 0 24px;
}

.logo-container {
  justify-content: flex-start;
  margin-right: auto;
  padding-left: 0;
  max-width: fit-content;
}

.logo {
  height: 50px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.desktop-menu {
  gap: 12px;
}

.menu-btn {
  color: white !important;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  position: relative;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-icon {
  transition: transform 0.2s ease;
}

.menu-text {
  position: relative;
}

.menu-text::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: white;
  transition: width 0.3s ease;
}

.menu-btn:hover .menu-text::after {
  width: 100%;
}

.menu-btn:hover .menu-icon {
  transform: translateY(-2px);
}

.mobile-menu-icon {
  color: white;
}

.mobile-menu-item {
  padding: 12px 24px;
}

.mobile-menu-text {
  position: relative;
}

.mobile-menu-text::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.8);
  transition: width 0.3s ease;
}

.mobile-menu-item:hover .mobile-menu-text::after {
  width: 100%;
}

@media (min-width: 961px) {
  .mobile-menu {
    display: none !important;
  }
}

@media (max-width: 960px) {
  .desktop-menu {
    display: none !important;
  }
  .sticky-header {
    height: 70px;
    padding: 0 16px;
  }
  .logo {
    height: 40px;
  }
}
</style>